import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MessageComponent } from './message.component';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  snackBar = inject(MatSnackBar);

  error = (message: string, duration = 5000) =>
    this.snackBar.openFromComponent(MessageComponent, {
      data: {
        message,
        icon: 'error'
      },
      duration,
      verticalPosition: 'top',
      panelClass: ['ERROR']
    });

  confirm = (message: string, duration = 5000) =>
    this.snackBar.openFromComponent(MessageComponent, {
      data: {
        message,
        icon: 'check_circle'
      },
      duration,
      verticalPosition: 'top',
      panelClass: ['CONFIRM']
    });
}
